import { render } from "./PresentationSectionSmallerImage.vue?vue&type=template&id=3403140b&scoped=true"
import script from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"
export * from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"

import "./PresentationSectionSmallerImage.vue?vue&type=style&index=0&id=3403140b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3403140b"]])

export default __exports__